


















import Vue, { PropType } from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import IntersectionDirective from './intersection-directive';

export interface ImageSourceInterface {
  src: string;
  maxWidth: number;
}

export interface ResponsiveImageInterface {
  src: string;
  mobileSrc: string;
  alt: string;
  sources: Array<ImageSourceInterface>;
}

export const placeholderUrl = 'data:image/gif;base64,R0lGODdhAQABAIABABcXF////ywAAAAAAQABAAACAkQBADs=';

const ResponsiveImageProps = Vue.extend({
  props: {
    placeholderUrl: {
      type: String,
      default: placeholderUrl,
    },
    pictureJson: String,
    pictureObject: Object as PropType<ResponsiveImageInterface>,
    objectFit: {
      type: String,
      default: 'cover',
    },
    loadedEvent: {
      type: Boolean,
      default: false,
    },
    disableLazyLoading: {
      type: Boolean,
      default: false,
    },
    imageClass: String,
  },
});

@Component({
  directives: {
    intersect: IntersectionDirective,
  },
})
export default class ResponsiveImage extends ResponsiveImageProps {
  $refs!: {
    img: HTMLImageElement;
  };

  loadingTriggered = false;

  // if the image is 50% below or above visible screen it should be loaded
  observerOptions = {
    rootMargin: '50%  0px 50% 0px',
  }

  mounted () {
    if (this.loadedEvent) {
      const { img } = this.$refs;
      img.onload = () => {
        if (img.src !== this.placeholderUrl) {
          const event = new CustomEvent('imgloaded', {
            bubbles: true,
            composed: true,
            detail: {
              img,
            },
          });
          this.$el.dispatchEvent(event);
        }
      };
    }
    if (this.disableLazyLoading) {
      this.loadingTriggered = true;
    }
  }

  handleIntersectChange (isIntersecting: boolean) {
    if (isIntersecting && !this.loadingTriggered) {
      this.loadingTriggered = true;
    }
  }

  mq (maxWidth: number | undefined) {
    if (maxWidth) {
      return `(max-width: ${maxWidth}px)`;
    }

    return null;
  }

  get sources () {
    return this.imageJson && this.loadingTriggered
      ? this.imageJson.sources
      : [];
  }

  get fallbackImage () {
    return this.imageJson && this.loadingTriggered
      ? this.imageJson.src
      : this.placeholderUrl;
  }

  get alt () {
    return this.imageJson
      ? this.imageJson.alt
      : null;
  }

  get imageJson (): ResponsiveImageInterface | null {
    if (this.pictureJson) {
      return JSON.parse(this.pictureJson);
    }
    if (this.pictureObject) {
      return this.pictureObject;
    }

    return null;
  }

  get modifierClass () {
    if (this.objectFit === 'cover') {
      return 'brandhub-picture--cover';
    }
    if (this.objectFit === 'contain') {
      return 'brandhub-picture--contain';
    }

    return null;
  }

  @Watch('disableLazyLoading')
  triggerImageLoading (lazyLoadingDisabled: boolean) {
    if (lazyLoadingDisabled) {
      this.loadingTriggered = true;
    }
  }
}
